
export class CurriculumDataDto {
    Id: number;
    Description: string;
    CourseYears: CourseYearsDataDto[] = [];
}

export class CourseYearsDataDto {
    Id: number;
    CourseYearName: string;
    CourseYearSubjects: SubjectDataDto[] = [];
}

export class SubjectDataDto {
    SubjectId: number;
    Name: string;
    Periods: number;
    IsActive = true;
}



// WEBPACK FOOTER //
// ./src/app/main/models/curricula/dto/curriculum-data.ts